module.exports = __webpack_public_path__ + "img/pdfPlaceholder.b940e727.jpeg";